import { Component, OnInit, AfterViewInit } from '@angular/core';

// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';

// Others
import 'apexcharts';
import { WHAT } from '../../shared/classes';
import Tabulator from 'tabulator-tables';


@Component({
    selector: 'app-active-user',
    templateUrl: './online-device.component.html',
    styleUrls: ['./online-device.component.less']
  })

  export class ActiveUsersComponent implements OnInit {
    private graph: ApexCharts;
    private table: Tabulator;

    public totalOverall = {
       overall : ""
    }
    constructor(private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService) {}

    ngOnInit(){
        this.load.show();
        this.initLoad()
        this.load.hide();
    }
    
    
    private async initLoad() {
        let data;
        try{
            data = await this.admin.GET(WHAT.UsersAnalysis,null,null,null,null,"query=active");
            this.totalOverall.overall = data.total;

            const accountCategoryData = Object.entries(data.user_account_category);
            const accountTypeData = Object.entries(data.user_account_type);

            const accountTypeChartOptions = {
                chart: {
                  type: 'bar'
                },
                series: [{
                  name: 'Total',
                  data: accountTypeData.map(([type, value]) => ({ x: type, y: value }))
                }],
                xaxis: {
                  categories: accountTypeData.map(([type]) => type)
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    colors: {
                      ranges: [{
                        from: 0,
                        to: 10000,
                        color: '#B90083' // Magenta color
                      }]
                    }
                  }
                },
              };
        
              const accountCategoryChartOptions = {
                chart: {
                  type: 'bar'
                },
                series: [{
                  name: 'Total',
                  data: accountCategoryData.map(([category, value]) => ({ x: category, y: value }))
                }],
                xaxis: {
                  categories: accountCategoryData.map(([category]) => category)
                },
                plotOptions: {
                  bar: {
                    horizontal: false,
                    colors: {
                      ranges: [{
                        from: 0,
                        to: 10000,
                        color: '#B90083' // Magenta color
                      }]
                    }
                  }
                },
              };
        
              this.graph = new ApexCharts(document.querySelector('#overall_account_type'), accountTypeChartOptions);
              this.graph.render();
        
              this.graph = new ApexCharts(document.querySelector('#overall_account_category'), accountCategoryChartOptions);
              this.graph.render();



              this.table = new Tabulator('#activeUsersTable', {
                responsiveLayout: 'collapse',
                pagination: 'local',
                paginationSize: 15,
                paginationSizeSelector: true,
                index: 'userid',
                layout: 'fitColumns',
                columns: [
                  { title: 'User ID', field: 'user_id', sorter: 'string' },
                  { title: 'Account Type', field: 'account_type', sorter: 'string' },
                  { title: 'Account Category', field: 'account_category', sorter: 'string' },
                  { title:'Online Devices',field:'online_devices',sorter:'string'},
                ],
              });

              this.table.addData(data.users);
        }
        catch(e){
            this.msg.error(e);
        }
    }
  }